import { combineReducers } from 'redux';

import user from './user.reducer';
import lSportsPrematch from './lsports.prematch.reducer';
import lSportsInplay from './lsports.inplay.reducer';
import betslip from './betslip.reducer';
import general from './general.reducer';

const reducer = combineReducers({
    general: general,
    user: user,
    lSports: combineReducers({
        prematch: lSportsPrematch,
        inplay: lSportsInplay,
    }),
    betslip: betslip,
});

export default reducer;
